<template>
  <FAQ :class="$style.faq">
    <TheContent
      v-for="item of props.elem.attributes.elem"
      :key="item.id"
      :elem="item"
    />
  </FAQ>
</template>

<script lang="ts" setup>
  import type { PropType } from 'vue';
  import TheContent from '~/components/content/TheContent';
  import FAQ from '@devhacker/shared/components/blocks/FAQ.vue';

  const props = defineProps({
    elem: {
      type: Object as PropType<TContent>,
      required: true,
    },
  });
</script>

<style lang="scss" module>
  @use '@devhacker/shared/styles/breakpoints' as breakpoints;

  .faq {
    margin-top: 24px;
    margin-bottom: 24px;

    --faq-header-font: bold 26px/34px #{$secondFont};
    --faq-space-after-header: 16px;
    --faq-question-font: bold 22px/30px #{$secondFont};
    --faq-answer-font: 16px/24px #{$mainFont};
    --faq-background: #f3f5fc;
    --faq-border: 1px solid #e1eafd;
    --faq-border-radius: 0;
    --faq-space-between-blocks: 16px;
    --faq-space-after-question: 12px;
    --faq-padding: 24px 16px;
    --faq-color: #000;
    --faq-space-above-button: 4px;

    @include breakpoints.tablet {
      --faq-header-font: bold 28px/36px #{$secondFont};
      --faq-question-font: bold 24px/32px #{$secondFont};
      --faq-answer-font: 18px/26px #{$mainFont};
      --faq-padding: 24px;
    }
  }
</style>
